import { render, staticRenderFns } from "./DiscountSaveForm.vue?vue&type=template&id=1bbec9f8&scoped=true"
import script from "./DiscountSaveForm.vue?vue&type=script&lang=js"
export * from "./DiscountSaveForm.vue?vue&type=script&lang=js"
import style0 from "./DiscountSaveForm.vue?vue&type=style&index=0&id=1bbec9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbec9f8",
  null
  
)

export default component.exports